import type { SVGProps } from "react";

export function IconBlackNavHealthcare(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00025 13.75H6.74288C5.74832 13.75 4.79449 14.1451 4.09123 14.8483L1.43958 17.5L6.00024 22.0607L9.3109 18.75H15.7576C16.7522 18.75 17.706 18.3549 18.4092 17.6517L22.3109 13.75H20.1896L17.3486 16.591C16.9266 17.0129 16.3543 17.25 15.7576 17.25H9.3109L7.3109 15.25H13.7502V13.75H9.00025V13.75ZM5.53883 15.5993L7.93958 18L6.00024 19.9393L3.5609 17.5L5.15189 15.909C5.27001 15.7909 5.39991 15.6873 5.53883 15.5993Z"
        fill="#0B0C17"
      />
      <path
        d="M9.38169 6.46165L13.8536 10.5758L18.3256 6.46165C19.3276 5.53976 19.4394 3.99734 18.5808 2.94058C17.6454 1.78926 15.9334 1.66361 14.8399 2.666L13.8536 3.5701L12.8674 2.666C11.7738 1.66361 10.0619 1.78926 9.12645 2.94058C8.26783 3.99734 8.37964 5.53976 9.38169 6.46165Z"
        fill="#0B0C17"
        stroke="#0B0C17"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
